<template>
  <v-card elevation="0">
    <SectionHeader class="d-none d-sm-block px-6 pt-4" title="Translate your document">
      <template #subtitle>
        <p class="body-1">
          <span class="font-weight-bold">Fill in the English translations</span> for each field below. The provider will only charge you for the empty fields or edits needed.
        </p>
        <p class="body-1 d-none d-md-block">
          Here's what to do:
          <ol>
            <li>Click on the field you wish to translate</li>
            <li>Add your translation in English. If you don't know, leave it blank and our translator will help you out.</li>
          </ol>
        </p>
      </template>
      <template #append-right>
        <JobInfoWidget class="ml-16" :text="translationTitle" :subtext="activity.language" />
      </template>
    </SectionHeader>
    <v-row v-if="fields && fields.length" no-gutters>
      <v-col>
        <div v-if="$vuetify.breakpoint.mdAndUp">
          <DesktopTranslateTable :completed-field-count="completedFieldCount" :fields="fields" @updateField="updateField($event)" @deleteField="deleteField($event)" />
        </div>
        <div v-else>
          <MobileTranslateForm :fields="fields" @updateField="updateField($event)" @deleteField="deleteField($event)" />
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import JobInfoWidget from '@/domains/jobs/components/JobInfoWidget.vue'
import SectionHeader from '@/domains/global/components/SectionHeader.vue'
import DesktopTranslateTable from './DesktopTranslateTable.vue'
import MobileTranslateForm from './MobileTranslateForm.vue'

export default {
  components: {
    SectionHeader,
    DesktopTranslateTable,
    JobInfoWidget,
    MobileTranslateForm
  },
  props: {
    activity: { type: Object, required: true },
    fields: { type: Array, required: true },
    translationTitle: { type: String, required: true },
    completedFieldCount: { type: Number, default: 0 }
  },
  methods: {
    updateField(data) {
      this.$emit('updateField', data)
    },
    deleteField(data) {
      this.$emit('deleteField', data)
    }
  }
}
</script>
